import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ConfirmationPage.css';

function ConfirmationPage({ student }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { answer, stats } = location.state || {};
  const [countdown, setCountdown] = useState(10);
  const fireworksContainerRef = useRef(null);

  useEffect(() => {
    // Auto-redirect to dashboard after 10 seconds
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 10000);

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownInterval);
    };
  }, [navigate]);

  // Fireworks effect for "Yes" answer
  useEffect(() => {
    if (answer === 'yes' && fireworksContainerRef.current) {
      const container = fireworksContainerRef.current;
      const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#f0932b', '#eb4d4b', '#6c5ce7', '#a29bfe'];
      
      const createFirework = (x, y) => {
        const particles = 30;
        for (let i = 0; i < particles; i++) {
          const particle = document.createElement('div');
          particle.className = 'firework-particle';
          
          const angle = (Math.PI * 2 * i) / particles;
          const velocity = 2 + Math.random() * 2;
          const color = colors[Math.floor(Math.random() * colors.length)];
          
          particle.style.left = x + 'px';
          particle.style.top = y + 'px';
          particle.style.backgroundColor = color;
          particle.style.setProperty('--vx', Math.cos(angle) * velocity);
          particle.style.setProperty('--vy', Math.sin(angle) * velocity);
          
          container.appendChild(particle);
          
          setTimeout(() => {
            particle.remove();
          }, 2000);
        }
      };

      // Create multiple firework bursts
      const burstPositions = [
        { x: window.innerWidth * 0.2, y: window.innerHeight * 0.3 },
        { x: window.innerWidth * 0.5, y: window.innerHeight * 0.2 },
        { x: window.innerWidth * 0.8, y: window.innerHeight * 0.3 },
        { x: window.innerWidth * 0.3, y: window.innerHeight * 0.5 },
        { x: window.innerWidth * 0.7, y: window.innerHeight * 0.5 },
      ];

      // Initial bursts
      burstPositions.forEach((pos, index) => {
        setTimeout(() => {
          createFirework(pos.x, pos.y);
        }, index * 200);
      });

      // Additional bursts after a delay
      setTimeout(() => {
        burstPositions.forEach((pos, index) => {
          setTimeout(() => {
            createFirework(pos.x + (Math.random() - 0.5) * 100, pos.y + (Math.random() - 0.5) * 100);
          }, index * 150);
        });
      }, 1500);
    }
  }, [answer]);

  const formatMinutes = (minutes) => {
    if (minutes < 60) {
      return `${minutes} minutes`;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (mins === 0) {
      return `${hours} hour${hours !== 1 ? 's' : ''}`;
    }
    return `${hours} hour${hours !== 1 ? 's' : ''} ${mins} minute${mins !== 1 ? 's' : ''}`;
  };

  const handleReturn = () => {
    navigate('/dashboard');
  };

  if (answer === 'yes') {
    return (
      <div className="confirmation-page">
        <div ref={fireworksContainerRef} className="fireworks-container"></div>
        <div className="confirmation-container success">
          <div className="confirmation-icon">🎉</div>
          <h1>Congratulations!</h1>
          <p className="confirmation-message">
            Great job reading today! Keep up the excellent work.
          </p>
          {stats && (
            <div className="confirmation-stats">
              <p>Your total reading time: <strong>{formatMinutes(stats.totalMinutes || 0)}</strong></p>
              <p>Current streak: <strong>{stats.currentStreak || 0} days</strong></p>
            </div>
          )}
          <button onClick={handleReturn} className="return-button">
            Return to Dashboard
          </button>
          <p className="auto-redirect">Redirecting automatically in {countdown} second{countdown !== 1 ? 's' : ''}...</p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="confirmation-page">
        <div className="confirmation-container encouragement">
          <div className="confirmation-icon">💪</div>
          <h1>That's okay!</h1>
          <p className="confirmation-message">
            Uh-oh! You forgot to read today? That's okay. Pick up the streak again tomorrow. Happy reading!
          </p>
          {stats && (
            <div className="confirmation-stats">
              <p>Your total reading time: <strong>{formatMinutes(stats.totalMinutes || 0)}</strong></p>
              <p>Current streak: <strong>{stats.currentStreak || 0} days</strong></p>
            </div>
          )}
          <button onClick={handleReturn} className="return-button">
            Return to Dashboard
          </button>
          <p className="auto-redirect">Redirecting automatically in {countdown} second{countdown !== 1 ? 's' : ''}...</p>
        </div>
      </div>
    );
  }
}

export default ConfirmationPage;

